const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const walletTopup = async (walletId, payload) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(`${BASE_URL}/eci/apis/v4/wallets/${walletId}/wallet_topup`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.detail || "Wallet top-up failed");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error topping up wallet:", error);
    throw error;
  }
};

/**
 * Subanchor (DSA) wallet top-up – new only.
 * POST .../wallets/{anchor_id}/dsa_wallets/{wallet_id}/wallet_topup
 */
export const subanchorWalletTopup = async (anchorId, walletId, payload) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(
      `${BASE_URL}/eci/apis/v4/wallets/${anchorId}/dsa_wallets/${walletId}/wallet_topup`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      let message = "Subanchor wallet top-up failed";
      if (data?.msg) {
        if (Array.isArray(data.msg)) {
          message = data.msg.map((e) => e?.value ?? e).join(" ") || message;
        } else if (typeof data.msg === "object" && data.msg?.detail) {
          message = data.msg.detail;
        } else if (typeof data.msg === "string") {
          message = data.msg;
        }
      } else if (data?.detail) {
        message = data.detail;
      }
      const err = new Error(message);
      err.data = data;
      throw err;
    }

    return data;
  } catch (error) {
    console.error("Error topping up subanchor wallet:", error);
    throw error;
  }
};
